import PropTypes from 'prop-types';
import { WideImage } from '@arpav/components/ArpavTheme/View';
import config from '@plone/volto/registry';

/**
 * ContentImage view component class.
 * @function ContentImage
 * @params {object} content: Content object.
 * @returns {string} Markup of the component.
 */
const ContentImage = ({ content, position }) => {
  const image = content?.image || content?.preview_image;
  const image_caption = content?.image_caption || content?.preview_camption;
  const view =
    (image || image_caption) && config.settings.arpavThemeViewsConfig.imagePosition === position;

  return view ? (
    <div className="content-image">
      <WideImage
        title={content?.title}
        image={image}
        caption={image_caption}
        fullWidth={config.settings.arpavThemeViewsConfig.imagePosition === 'afterHeader'}
      />
    </div>
  ) : null;
};
export default ContentImage;

ContentImage.propTypes = {
  params: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.shape({
      download: PropTypes.string,
    }),
    caption: PropTypes.string,
    fullWidth: PropTypes.bool,
  }),
};
